import React, { useEffect } from 'react';
import { PrismButton, PrismCard } from '@prism-ui/react';
import { IntroVideoCard } from '../Requirements/IntroVideoCard';
import { APPLICATION_STATUS_ID_SUBMITTED } from '../constants';
const InfoStep = ({ currentUser, application, saveApplication, jumpToStep }) => {

  // Check if application exists and is submitted
  const isApplicationSubmitted = application && application.status_id === APPLICATION_STATUS_ID_SUBMITTED;
  
  // BUG FIX: Move jumpToStep logic into useEffect to prevent infinite re-renders
  useEffect(() => {
    if (isApplicationSubmitted && jumpToStep) {
      // If submitted, jump to step 2 (skip Chapter step)
      jumpToStep(2);
    }
  }, [isApplicationSubmitted, jumpToStep]);
  
  const handleBegin = () => {
    // Jump to the Chapter step (step 1)
    if (jumpToStep) {
      jumpToStep(1); // Go to step 1 (Chapter step)
    }
  };

  return (
    <div style={{ maxWidth: '800px', margin: '0 auto' }}>
      <h3 style={{ marginBottom: '0.5rem', textAlign: 'center' }}>Welcome to CLEAR</h3>
      <p style={{ marginBottom: '1.5rem', color: 'var(--color-text-faded)', textAlign: 'center' }}>
        Watch the info session below, then hit <strong>Begin</strong> to start your application.
      </p>

      <IntroVideoCard />

      <PrismCard display="static" style={{ marginTop: '1.5rem' }}>
        <h5 style={{ margin: '0 0 0.75rem' }}>Eligibility Guidelines</h5>
        <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '1.25rem' }}>
          <div>
            <div style={{ fontWeight: 600, marginBottom: '0.25rem' }}>Comcast</div>
            <div style={{ fontSize: '0.9rem', color: 'var(--color-text-faded)' }}>
              <em>Effective</em> or <em>Outstanding</em> on your last performance review, with no corrective action in the last 12 months.
            </div>
          </div>
          <div>
            <div style={{ fontWeight: 600, marginBottom: '0.25rem' }}>Sky UK</div>
            <div style={{ fontSize: '0.9rem', color: 'var(--color-text-faded)' }}>
              <em>PDP 3</em> or above in your last rating cycle.
            </div>
          </div>
        </div>
      </PrismCard>

      <div style={{ textAlign: 'center', marginTop: '2.5rem' }}>
        <PrismButton
          tone="primary-brand"
          size="lg"
          onPrismClick={handleBegin}
        >
          BEGIN
        </PrismButton>
      </div>
    </div>
  );
};

export default InfoStep;